export default __webpack_public_path__ + "static/media/047-wheelchair.b61edc99.svg";